module.exports = __webpack_public_path__ + "img/Main-Page-Clarity_Still.a90ae0b0.jpg";